<script setup>
import PickStock from "@/components/warehouse/PickStock"
import SlideInDrawer from "@/components/common/navigation/SlideInDrawer";
import DataGrid from "@/components/common/other/DataGrid";
import Table from "@/components/common/other/Table";
import Button from "@/components/common/input/Button";
import DocumentUpload from "@/components/common/other/DocumentUpload";

import {inject, ref, onMounted} from 'vue';

import {useStore} from 'vuex';
import API from "@/classes/global/API";

const store = useStore();

const pickStock = inject("pickStock");

const updateGridRender = ref();

</script>

<template>
  <SlideInDrawer
      :height="395"
      title="Picked Stock"
      v-model:open-drawer="pickStock.openPicksDrawer">
    <div style="margin-top: 30px;">
      <Table
          :key="updateGridRender"
          :allowGridMenu="false"
          height="260"
          :page-size="180"
          :selectable="false"
          :row-selection="false"
          :dataSource="pickStock.pickedItems"
          :columns="pickStock.pickedItemGridColumns">
        <template v-slot:unPick="row">
          <Button
              type="danger"
              text="Unpick">
          </Button>
        </template>
      </Table>
    </div>
  </SlideInDrawer>
  <SlideInDrawer
      :height="320"
      title="Upload Documents"
      v-model:open-drawer="pickStock.openDocsDrawer">
      <DocumentUpload v-model="pickStock"></DocumentUpload>
  </SlideInDrawer>
  <PickStock
      @update-picked-items="updateGridRender = $event"
      v-model="pickStock">
  </PickStock>

</template>

<style scoped>

</style>
